import { Game } from '../../../../features/game/types/Game'

export type DashboardSummary = {
  withoutAnalysis: number
  outdated: number
}

// The first version of a game that no analysis covers yet.
export type DashboardVersion = {
  version?: string
  versionReleaseDate?: number
  releaseNotes?: string
}

export type DashboardOutdatedGames = {
  games: Game[]
  versions: Record<string, DashboardVersion>
}

export type GameNote = { notes?: string }
export type GameNotesMap = Record<string, GameNote>

export type TopGrossingHistoryEntry = { ts: number; rank: number }

// A top-grossing game as `games/{iso}/games/{appIds}` answers it.
export type TopGrossingRankedGame = {
  appId: number
  rank?: number
  history?: TopGrossingHistoryEntry[]
}

export type DashboardGameRow = {
  key: string
  // `id` is the game's id, or '' when the top-grossing entry has none.
  game: Game
  rank?: number
  freeRank?: number
  powerscore?: number
  daysInTop200?: number
  firstUnanalyzedVersion?: DashboardVersion
}

export enum RankType {
  Grossing = 'grossing',
  Free = 'free',
}

export enum DashboardColumn {
  Analyst = 'analyst',
  Rank = 'rank',
  FreeRank = 'freeRank',
  Icon = 'icon',
  Name = 'name',
  Publisher = 'publisher',
  Subgenre = 'subgenre',
  Powerscore = 'powerscore',
  Ftue = 'ftue',
  AnalystOverview = 'analystOverview',
  DaysInTop200 = 'daysInTop200',
  FirstUnanalyzedVersion = 'firstUnanalyzedVersion',
}

export enum DashboardAction {
  ViewAnalyses = 'viewAnalyses',
  Edit = 'edit',
  VersionTags = 'versionTags',
  Delete = 'delete',
  Unpin = 'unpin',
}

export type DashboardActionHandler = (action: DashboardAction, row: DashboardGameRow) => void

// Game id → the subgenre stored by an edit in this visit.
export type StoredSubgenres = Record<string, string | null | undefined>

export type DashboardListDialogProps = {
  open: boolean
  marketIso: string
  onClose: () => void
  onAction: DashboardActionHandler
  storedSubgenres: StoredSubgenres
}

export const allAnalystsId = 'all'
export const freeRankUnranked = 2000
